export default class VacancySmall {
  constructor(id, title, info, date, image_url, city_id) {
    this.id = id;
    this.title = title;
    this.info = info;
    this.date = date;
    this.image_url = image_url;
    this.city_id = city_id;
  }

  // ✅ Метод для парсинга JSON в объект VacancySmall
  static fromJson(json) {
    return new VacancySmall(
      json.id || "",
      json.title || "Без названия",
      json.info || "Описание отсутствует",
      json.dateOfCreate || "",
      json.image_url || "",       // ✅ добавлено
      json.city_id || ""          // ✅ добавлено
    );
  }
}